export var TypeResource;
(function (TypeResource) {
    TypeResource["WheelShopPoints"] = "wheelShopPoints";
    TypeResource["WheelTickets"] = "wheelTickets";
    TypeResource["CityManagement"] = "cityManagement";
    TypeResource["Keys"] = "keys";
    TypeResource["Seed"] = "seed";
    TypeResource["SeedPrm"] = "seedPrm";
    TypeResource["SeedSpecial"] = "seedSpecial";
    TypeResource["FeedPrm"] = "feedPrm";
    TypeResource["FeedIns"] = "feedIns";
    TypeResource["StableProduct2"] = "stableProduct2";
    TypeResource["FertilizerPrm"] = "fertilizerPrm";
    TypeResource["FertilizerIns"] = "fertilizerIns";
    TypeResource["Te1Pellet"] = "te1Pellet";
    TypeResource["Te2Pellet"] = "te2Pellet";
    TypeResource["Te3Pellet"] = "te3Pellet";
    TypeResource["Te4Pellet"] = "te4Pellet";
    TypeResource["Te5Pellet"] = "te5Pellet";
    TypeResource["Currency"] = "currency";
    TypeResource["LoyaltyPoints"] = "loyaltyPoints";
    TypeResource["TournamentPoints"] = "tournamentPoints";
    TypeResource["Water"] = "water";
    TypeResource["Snippets"] = "snippets";
    TypeResource["ContractsResources"] = "contractsResources";
    TypeResource["Feed"] = "feed";
    TypeResource["FeedSuper"] = "feedSuper";
    TypeResource["Fertilizer"] = "fertilizer";
    TypeResource["FertilizerSuper"] = "fertilizerSuper";
    TypeResource["OrchardProduct2"] = "orchardProduct2";
    TypeResource["Coupons"] = "coupons";
    TypeResource["Materials"] = "materials";
    TypeResource["CafeResources"] = "cafeResources";
})(TypeResource || (TypeResource = {}));



//////////////////
// WEBPACK FOOTER
// ./src/features/balancing/TypeResource.ts
// module id = 548
// module chunks = 3